// import logo from './logo.svg';
import React from "react";

import {Routes, Route} from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Property from "./pages/Property";
// import Banner from "./components/Banner";

function App() {
  return (
    <div className="min-h-screen overflow-hidden bg-[#f6f1e8] text-slate-900">
       <Header/>
       <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/property/:id" element={<Property />} />
       </Routes>
       <Footer/>
    </div>
  );
}

export default App;
